module.exports = __webpack_public_path__ + "static/media/default-img-220x226.82bd4212.png";